const FreedomAppConfig = (() => {
    /* global freedomApp */
    const customSettings = typeof(freedomApp) === 'object' ? freedomApp : {};

    const primaryColor = customSettings['primaryColor'] ?? '#1c1733';
    const secondaryColor = customSettings['secondaryColor'] ?? '#33bed4';

    let AppConfig = {
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        // MAIN MANDATORY SELECT SETUPS
        types: `ac-activity, ag-age, ft-format`,
        activities: `
        ac-group fitness,ac-aquatics,ac-sports,ac-youth experiences,ac-arts & culture,ac-in the kitchen,ac-community building,ac-family,ag-0 to pre-k,ag-0 to pre k,ag-K to 4,ag-5 to 8 grade,ag-9 to 12 grade,ag-18+ years,ft-on demand,ft-at the j,ft-online 
        `,

        // <<< ICONS >>>
        // NOTE -- these are all custom. Name that as icon_WHATEVER YOUR ACTIVITY IS
        // tHIS IS THE CLASS(S) USED FORT THE ICON. Set as many as you are using above in activities
        // CANNOT HAVE SPACES FOR NAME. USE UNDERSCORES INSTEAD OF SPACES.
        // EXAMPLES:
        //'icon_tennis': 'mdi mdi-tennis',
        // 'icon_group_exercise': 'mdi mdi-account-group-outline',

        eventFormatPrefix: 'ft',
        eventFeaturedTag: 'Staff Pick',

        // On Demand Stuff (Directory Items)
        dirName: 'ondemand', // MUST BE SETUP for directory [on demand] items to work
        dirString: 'On Demand',
        dirMaxVisible: 3, // Maximum number of items to list before showing a "view more" link to directory lister
        dirDescField: 'misc0',
        dirReadMoreText: 'Watch Now',
        dirVideoField: 'misc1',
        dirViewAllLinkText: 'View All',

        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////


        // BOOLEAN FLAGS
        showTodayChip: 'yes', // Shows the 'TODAY' text under the date for today, and as a cutout 'chip' ont he date when selected
        useSearch: 'yes',
        searchIcon: 'yes',

        // CSS Sizes
        iconSize: '30px',
        gutterMinWidth: '1000px',
        gutterMaxWidth: '1200px',

        // String Templates (lodash)
        eventLinkTemplate: 'index.php?src=events&srctype=detail&refno=<%= id %>',
        dirLinkTemplate: 'index.php?src=directory&view=<%= directory %>&srctype=detail&refno=<%= id %>',
        dirLinkViewAllTemplate: 'index.php?src=directory&view=<%= directory %>',

        // Moment.js Date Formats
        eventDateTitleFormat: 'dddd, MMMM D',
        dateSelectFormat: 'ddd DD',

        //how many days of events to show on page load
        daysToLoad: 14,

        // Text Strings
        noEventsText: `No Events Matching Search Criteria`,
        todayText: `TODAY`,
        typeHeadline: `Narrow Your Search:`,
        searchPlaceholder: `Search...`,

        // Colors
        typeColor: secondaryColor,
        typeSelectedColor: '#fff',
        bannerColor: '#f4f4f4',
        dateBannerColor: '#f5f5f5',
        eventFormatColor: secondaryColor,
        dateSelectedBackgroundColor: primaryColor,
        dateSelectedColor: '#ffffff',
        dateColor: primaryColor,
        groupColor: primaryColor,
        groupSelectedColor: secondaryColor,
        eventDateTitleColor: primaryColor,
        eventBottomBorderColor: '#e8e8e8',
        searchIconColor: primaryColor,
        filterButtonClass: 'hollow',
        filterButtonClassActive: 'solid'
    };

    //////////////////////////////////////////////////////////////////////
    // Replace default values with any set to a global freedomApp object
    if (typeof(customSettings) === 'object' && Object.keys(customSettings).length) {
        Object.keys(customSettings).forEach(k => AppConfig[k] = customSettings[k]);
    }/////////////////////////////////////////////////////////////////////

    return AppConfig;
})();
export default FreedomAppConfig;